module.exports = __webpack_public_path__ + "img/arrow_back-black-18dp.e5a7ab0f.svg";